
export default {
	name: 'ICardCompare',
	props: {
    users: {
      type: Object,
      default: () => {
        return {};
      }
    },
		cardImg: {
			type: String,
			default: '',
			// required: true
		},
		cardName: {
			type: String,
			default: '',
		},
		cardAge: {
			type: Number,
			default: null,
		},
		cardStatus: {
			type: Boolean,
			default: false,
		}
  },
	data() {
    return {
			randomUserFirst: '',
			randomUserSecond: '',
			list: ['Ashley','Andy','Andrew','Chad','Hiep','Sarah','David'],
    }
  },
	created() {
		this.randomCraete();
  },
	methods: {
    applyImgSrc: function(_sUrl) {
			if (_sUrl != undefined || _sUrl != null) {
				return "//loveinchat.com" + _sUrl;
			}
    },
		randomCraete(start, end){

			do {
				start = Math.floor(Math.random() * this.users.length);
			} while(start === end);

			do {
				end = Math.floor(Math.random() * this.users.length);
			} while(end === start);

			this.randomUserFirst = this.users[start];

			this.randomUserSecond = this.users[end];
		}
	}
}